// App版本管理相关API服务
// 根据 Go 后端接口文档实现
import { httpClient } from '../http';
import {
  AppVersion,
  CreateAppVersionRequest,
  UpdateAppVersionRequest,
  AppVersionListParams,
  PaginationResponse,
  PublishAppVersionRequest,
  PauseAppVersionRequest,
  ResumeAppVersionRequest,
} from '@/types/api';

export class AppVersionsAPI {
  /**
   * 获取App版本列表（分页）
   * GET /admin/app-versions
   * @param params 查询参数：page, size, search, status
   */
  async getAppVersions(params?: AppVersionListParams): Promise<PaginationResponse<AppVersion>> {
    const response = await httpClient.get<PaginationResponse<AppVersion>>('/admin/app-versions', params);
    return response.data;
  }

  /**
   * 获取App版本详情
   * GET /admin/app-versions/{id}
   * @param id 版本ID
   */
  async getAppVersionById(id: number): Promise<AppVersion> {
    const response = await httpClient.get<AppVersion>(`/admin/app-versions/${id}`);
    return response.data;
  }

  /**
   * 创建App版本
   * POST /admin/app-versions
   * @param versionData 创建版本请求数据
   */
  async createAppVersion(versionData: CreateAppVersionRequest): Promise<AppVersion> {
    const response = await httpClient.post<AppVersion>('/admin/app-versions', versionData);
    return response.data;
  }

  /**
   * 更新App版本
   * PUT /admin/app-versions/{id}
   * @param id 版本ID
   * @param versionData 更新版本请求数据
   */
  async updateAppVersion(id: number, versionData: UpdateAppVersionRequest): Promise<AppVersion> {
    const response = await httpClient.put<AppVersion>(`/admin/app-versions/${id}`, versionData);
    return response.data;
  }

  /**
   * 删除App版本
   * DELETE /admin/app-versions/{id}
   * @param id 版本ID
   */
  async deleteAppVersion(id: number): Promise<void> {
    await httpClient.delete(`/admin/app-versions/${id}`);
  }

  /**
   * 发布App版本
   * POST /admin/app-versions/publish
   * @param request 发布请求（version_id）
   */
  async publishAppVersion(request: PublishAppVersionRequest): Promise<void> {
    await httpClient.post('/admin/app-versions/publish', request);
  }

  /**
   * 暂停App版本发布
   * POST /admin/app-versions/pause
   * @param request 暂停请求（version_id）
   */
  async pauseAppVersion(request: PauseAppVersionRequest): Promise<void> {
    await httpClient.post('/admin/app-versions/pause', request);
  }

  /**
   * 恢复App版本发布
   * POST /admin/app-versions/resume
   * @param request 恢复请求（version_id）
   */
  async resumeAppVersion(request: ResumeAppVersionRequest): Promise<void> {
    await httpClient.post('/admin/app-versions/resume', request);
  }
}

// 导出单例实例
export const appVersionsAPI = new AppVersionsAPI();

